import classnames from "classnames"
import Styles from "./Switch.module.scss";

interface SwitchProps {
    isChecked: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

const Switch = ({
    isChecked,
    disabled = false,
    onClick,
}: SwitchProps) => {
    return (
    <input className={Styles.switch} checked={isChecked} disabled={disabled} onChange={()=>{}} onClick={onClick} type="checkbox" />
    );
};

export default Switch;